import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResponseModel } from 'src/app/modules/auth/_models/response.model';
import { environment } from 'src/environments/environment';
import { UserDataModel, UserUpdateDTO } from '@modules/auth';
import { map } from 'rxjs/operators';

const API_USERS_URL = `${environment.apiUrl}`;

@Injectable({
  providedIn: 'root',
})
export class HttpUserProfileService {
  constructor(private http: HttpClient) {
  }

  updateProfile(user: UserUpdateDTO): Observable<ResponseModel<UserDataModel>> {
    return this.http.post<ResponseModel<UserDataModel>>(`${API_USERS_URL}/v1/UserProfile/update-user-profile`, user);
  }

  updateUserProfile({userId, ...user}: UserUpdateDTO, isAdmin = false): Observable<ResponseModel<UserDataModel>> {
    return this.http.post<ResponseModel<UserDataModel>>(`${API_USERS_URL}/v1/UserProfile/admin-update-user-profile`, {
      ...user,
      Admin: isAdmin ? 1 : 3,
    }, {params: {userId}});
  }

  getMyProfile(): Observable<ResponseModel<UserDataModel>> {
    return this.http.get<ResponseModel<UserDataModel & {birthdate: string}>>(`${API_USERS_URL}/v1/UserProfile/get-user-profile`).pipe(
      map((it) => ({
        ...it, data: {
          ...it.data,
          birthDate: it.data?.birthdate,
        },
      })),
    );
  }

  getUserProfileById(userId: number): Observable<ResponseModel<UserDataModel>> {
    return this.http.get<ResponseModel<UserDataModel>>(`${API_USERS_URL}/v1/UserProfile/get-user-profile/${userId}`);
  }

  deleteProfile(): Observable<boolean> {
    return this.http.delete<ResponseModel<boolean>>(`${API_USERS_URL}/v1/UserProfile`).pipe(
      map((response) => response.data),
    )
  }

  getAllUsers(params?: {
    PageSize?: string,
    PageNumber?: string,
    SearchKey?: string,
    GroupId?: string,
    OnlineOnly?: string,
  }): Observable<ResponseModel<UserDataModel[]>> {
    return this.http.get<ResponseModel<UserDataModel[]>>(`${API_USERS_URL}/v1/User/get-all-users`, {params});
  }

  blockUser(userId: string): Observable<boolean> {
    return this.http.post<ResponseModel<boolean>>(`${API_USERS_URL}/v1/UserBlocks/${userId}`, {}).pipe(
      map((result) => result.data)
    );
  }

  unblockUser(userId: string): Observable<boolean> {
    return this.http.delete<ResponseModel<boolean>>(`${API_USERS_URL}/v1/UserBlocks/${userId}`).pipe(
      map((result) => result.data)
    );
  }

  isBlockedBy(userId: string): Observable<boolean> {
    return this.http.get<ResponseModel<boolean>>(`${API_USERS_URL}/v1/UserBlocks/is-blocked-by/${userId}`).pipe(
      map((result) => result.data)
    );
  }

  // users, which blocked by current user
  getBlockedUsersList(): Observable<number[]> {
    return this.http.get<ResponseModel<number[]>>(`${API_USERS_URL}/v1/UserBlocks`).pipe(
      map((result) => result.data)
    );
  }

  // users, who blocked current user
  getBlockedByUsersList(): Observable<string[]> {
    return this.http.get<ResponseModel<string[]>>(`${API_USERS_URL}/v1/UserBlocks/blocked-by`).pipe(
      map((result) => result.data)
    );
  }
}
